var path = '/pages/seatplans/views/seatplans-list.tpl.html';
var html = "<listview ng-if=\"vm.store\" store=\"vm.store\"></listview>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/seatplans/views/seatplans-list.tpl.html
// module id = 2312
// module chunks = 1